import getFullName from "@/helpers/getFullName";

const getUserFullData = (givenName: string, familyName: string, email?: String) => {
  const fullName = getFullName(givenName, familyName);

  if (!email) {
    return fullName;
  }

  return `${fullName} - ${email}`;
}

export default getUserFullData;